import React from 'react';
import { replaceTextURLToLink } from 'utils/utils.js';

import { DescriptionSection, SectionTitle, ContentArea } from './style';
export default function ChallengeDescription({description}) {
    let descriptionTxt = null
    if(description)
    {
       descriptionTxt = replaceTextURLToLink(description);
    }
    
    return(
       <DescriptionSection>
           <SectionTitle>어떤 챌린지 인가요?</SectionTitle>
            <ContentArea>{descriptionTxt}</ContentArea>
       </DescriptionSection>
    );
}
